import { useMemo, useState } from "react";
import { useAllNormasTeachingCoupons } from "../../ProductService/NormasTeachingCoupon/useAllNormasTeachingCoupons.ts";
import { matchesItemSearch } from "../../UI/Utils/matchesItemSearch.ts";
import { FilterActions } from "../../UI/Table/Filters/FilterActions.tsx";
import { COUPON_FILTER_LABELS, CouponFilter } from "./CouponFilter.ts";

function CouponOption({
  label,
  isSelected,
  onSelect,
}: {
  label: string;
  isSelected: boolean;
  onSelect: () => void;
}) {
  return (
    <label className="flex cursor-pointer items-center gap-2 rounded-md px-1 py-1 text-sm text-gray-700 hover:bg-gray-50">
      <input
        type="radio"
        name="coupon-filter"
        checked={isSelected}
        onChange={onSelect}
        className="w-4 h-4 shrink-0 accent-primary"
      />
      <span className="truncate">{label}</span>
    </label>
  );
}

export function CouponColumnFilter({
  value,
  onApply,
  close,
}: {
  value?: string;
  onApply: (coupon: string | undefined) => void;
  close: () => void;
}) {
  const { coupons } = useAllNormasTeachingCoupons();
  const [selected, setSelected] = useState(value);
  const [search, setSearch] = useState("");

  const couponCodes = useMemo(
    () =>
      coupons
        .map((coupon) => coupon.couponCode)
        .sort((a, b) => a.localeCompare(b)),
    [coupons],
  );
  const visibleCouponCodes = couponCodes.filter((code) =>
    matchesItemSearch(search, [code]),
  );

  const apply = (coupon: string | undefined) => {
    onApply(coupon);
    close();
  };

  return (
    <div className="flex flex-col gap-2 px-2">
      <div className="flex flex-col gap-0.5">
        {Object.values(CouponFilter).map((filter) => (
          <CouponOption
            key={filter}
            label={COUPON_FILTER_LABELS[filter]}
            isSelected={selected === filter}
            onSelect={() => setSelected(filter)}
          />
        ))}
      </div>
      <hr className="border-gray-100" />
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Cerca codice coupon"
        className="w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm"
      />
      <div className="max-h-48 overflow-y-auto flex flex-col gap-0.5">
        {visibleCouponCodes.map((code) => (
          <CouponOption
            key={code}
            label={code}
            isSelected={selected === code}
            onSelect={() => setSelected(code)}
          />
        ))}
        {visibleCouponCodes.length === 0 && (
          <p className="py-2 text-center text-sm text-gray-400">
            Nessun coupon trovato
          </p>
        )}
      </div>
      <FilterActions
        canClear={!!value}
        onClear={() => apply(undefined)}
        onApply={() => apply(selected)}
      />
    </div>
  );
}
